

























import { Component, Prop, Vue } from 'vue-property-decorator';
import { Facility } from '@/models/facility';
import IconEdit from '@/components/IconEdit.vue';
@Component({
  name: 'facility-preview',
  components: {
    IconEdit,
  },
})
export default class FacilityPreview extends Vue {
  @Prop({ type: String }) selectedFacilityLabel?: string;
  @Prop({ type: String }) changeFacilityButtonText?: string;
  @Prop({ type: Object, required: true }) facility!: Facility;
  @Prop({ type: Boolean, default: false }) showChangeButton?: boolean;
}
